import { render } from "./ActivityListComponent.vue?vue&type=template&id=2d20e63e&scoped=true"
import script from "./ActivityListComponent.vue?vue&type=script&lang=js"
export * from "./ActivityListComponent.vue?vue&type=script&lang=js"

import "./ActivityListComponent.vue?vue&type=style&index=0&id=2d20e63e&scoped=true&lang=css"

import exportComponent from "C:\\_TimetipCode\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d20e63e"]])

export default __exports__